import { useEffect, useState } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../assets/img/fondo-diseno.jpg';

function Login() {  
const navigate = useNavigate();
const[user,setUser]=useState('')
const[password,setPassword]=useState('')

const Login = async () => {
console.log(user,password)
fetch(`https://msensorapi.coolproyectdata.online/login.php`, {
method: "POST",
headers: {
Accept: "application/json",
'Content-Type': 'application/x-www-form-urlencoded',
},
body:JSON.stringify({
"email":user,
"password":password
})
})
.then((response) => response.json())
.then((responseData) => {
console.log(JSON.stringify(responseData),"Login Result")
//  

if(responseData.status === 'Incorrect Password'){
alert("Incorrect Password!");
}
else if(responseData.status === 'User Not Found'){
    alert("User Not Found!");
}else{
    alert("Login Successful!");

    localStorage.setItem('cid', (JSON.stringify(responseData.Customer_id)));
    if(responseData.Customer_id === "6"){
        navigate('/Dashboard')
    }else{
        navigate('/Home')
    }
     
    //{"Customer_id":"2","status":"Login Successfully"}
}

})
}

useEffect(()=>{
const login = localStorage.getItem('cid');
console.log(login,"cid")
if( login === ''|| login === null || login === "null" || login === "undefined" || login === undefined){
console.log(login,"login already exist")
}
else{
   if(login === "6"){
    navigate('/Dashboard')
   }else{
    navigate('/Home')
   }
 
}
},[])


return (
    <div
      style={{ backgroundImage: `url(${backgroundImage})` }}
      className="u-body u-xl-mode"
      data-lang="en"
    >
      <section className="u-section-1" id="sec-5b86">
        <div className="u-clearfix u-sheet u-sheet-1">
          <div
            style={{
              backgroundColor: "rgba(102, 16, 242, 0.0)",
            }}
            className="u-align-center u-container-style u-expanded-width-xs u-grey-90 u-group u-radius-5 u-shape-round u-group-1"
          >
            <div
              style={{
                backgroundColor: "rgba(102, 16, 242, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                padding: "20px",
              }}
              className="u-container-layout u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xl u-container-layout-1"
            >
              {/* Logo Section */}
              <div
                style={{
                  backgroundColor: "rgba(62, 16, 242, 0.5)",
                  width: "170px",
                  height: "140px",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  border: "3px solid rgba(120, 150, 202, 0.8)",
                  borderRadius: "7px",
                }}
              >
                <img
                  alt=""
                  src={require("../assets/img/logo.png")}
                  style={{
                    width: "160px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />
              </div>
 
              {/* Login Form */}
              <div className="u-form u-login-control " style={{ width: "100%", maxWidth: "400px" }}>
                {/* Email Input */}
                <div style={{color:"#fff",fontWeight:"700",fontSize:"50px",}}>LOG IN</div>
                <div className="u-form-group u-form-name u-label-top mt-3">
                <img
                  alt=""
                  src={require("../assets/img/user.png")}
                  style={{
                    width: "37px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />Email
                  <input
                    type="text"
                    placeholder="Enter your Email"
                    id="username-a30d"
                    name="email"
                    className="u-border-8 u-border-white mt-1 u-input u-input-rectangle u-radius-4 u-white u-input-2"
                    onChange={(e) => setUser(e.target.value)}
                    required=""
                    style={{ width: "100%" }}
                  />
                </div>
  
                {/* Password Input */}
                <div className="u-form-group u-form-password u-label-top mt-3">
                <img
                  alt=""
                  src={require("../assets/img/key.png")}
                  style={{
                    width: "32px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />  Password
                  <input
                    type="password"
                    placeholder="Enter your Password"
                    id="password-a30d"
                    name="password"
                    className="u-border-8 u-border-white mt-2 u-input u-input-rectangle u-radius-4 u-white u-input-2"
                    onChange={(e) => setPassword(e.target.value)}
                    required=""
                    style={{ width: "100%" }}
                  />
                </div>
  
                {/* Login Button with Row Layout */}
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "15%",
                  }}
                  className="u-align-center u-form-group u-form-submit u-label-top"
                >
                  <button
                    onClick={() => Login()}
                    className="u-border-none mt-3   u-radius-4  "
                    style={{
                      border: "none",
                      width: "30%",
                      fontWeight: "700",
                      height: "50px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      backgroundColor: "#007bff",
                      padding: "0px",
                    }}
                  >
                    Log in
                  </button>
                  <span  onClick={() => {
                    navigate("/ForgotPassword");
                  }} style={{ color: "#fff", fontWeight: "600",width:"50%",textAlign:"right" }}>Forgot Password</span>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
  
}

export default Login;